export const FCL_EXPORT_BOOKING_REPORT_LIST = "FCL_EXPORT_BOOKING_REPORT_LIST";
export const FCL_EXPORT_BOOKING_REPORT_SUMMARY = "FCL_EXPORT_BOOKING_REPORT_SUMMARY";
export const FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS = "FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS";

export const FCL_EXPORT_SALESPERSON_REPORT_LIST = "FCL_EXPORT_SALESPERSON_REPORT_LIST";
export const FCL_EXPORT_SALESPERSON_REPORT_SUMMARY = "FCL_EXPORT_SALESPERSON_REPORT_SUMMARY";
export const FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS = "FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS";
export const FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS = "FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS";
export const FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST = "FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST";

export const FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_LIST = "FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_LIST";
export const FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_SUMMARY = "FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_SUMMARY";
export const FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_CONTAINER_TEUS = "FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_CONTAINER_TEUS";


export const FCL_EXPORT_DOC_CO_ALERT_REPORT_LIST = "FCL_EXPORT_DOC_CO_ALERT_REPORT_LIST";
export const FCL_EXPORT_TOP_FIFTY_CUSTOMERS_REPORT_LIST = "FCL_EXPORT_TOP_FIFTY_CUSTOMERS_REPORT_LIST";
export const FCL_EXPORT_TOP_FIFTY_SUMMARY_REPORT_LIST = "FCL_EXPORT_TOP_FIFTY_SUMMARY_REPORT_LIST"
export const FCL_EXPORT_AUTO_CUT_OFF_ALERT_REPORT_LIST = "FCL_EXPORT_AUTO_CUT_OFF_ALERT_REPORT_LIST";


export const FCL_EXPORT_RATE_QUOTE_REPORT_LIST = "FCL_EXPORT_RATE_QUOTE_REPORT_LIST";
export const FCL_EXPORT_RATE_QUOTE_REPORT_NOT_BOOKED_EMAIL_LIST = "FCL_EXPORT_RATE_QUOTE_REPORT_NOT_BOOKED_EMAIL_LIST";
export const FCL_EXPORT_RATE_QUOTE_REPORT_SUMMARY = "FCL_EXPORT_RATE_QUOTE_REPORT_SUMMARY";
export const FCL_EXPORT_RATE_QUOTE_REPORT_STATUS_COUNTS = "FCL_EXPORT_RATE_QUOTE_REPORT_STATUS_COUNTS";
export const FCL_EXPORT_RATE_QUOTE_REPORT_TREND = "FCL_EXPORT_RATE_QUOTE_REPORT_TREND";
export const FCL_EXPORT_RATE_QUOTE_REPORT_SALES_PERSON_SUMMARY = "FCL_EXPORT_RATE_QUOTE_REPORT_SALES_PERSON_SUMMARY";
export const FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_SUMMARY = "FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_SUMMARY";
export const FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_NOT_BOOKED_SUMMARY = "FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_NOT_BOOKED_SUMMARY";

export const FCL_EXPPRT_ONBOARD_STATUS_ADUIT_REPORT_LIST = "FCL_EXPPRT_ONBOARD_STATUS_ADUIT_REPORT_LIST";
export const FCL_EXPORT_MBL_PROOFING_REPORT = 'FCL_EXPORT_MBL_PROOFING_REPORT';
export const FCL_EXPORT_ADVANCED_STATUS_REPORT = 'FCL_EXPORT_ADVANCED_STATUS_REPORT';
export const FCL_EXPORT_TASK_AUDIT_REPORT = 'FCL_EXPORT_TASK_AUDIT_REPORT';
export const FCL_EXPORT_TASK_AUDIT_ARRIVAL_POD_PRE_ALERT_REPORT = 'FCL_EXPORT_TASK_AUDIT_ARRIVAL_POD_PRE_ALERT_REPORT';
export const FCL_EXPORT_DAILY_SALES_PERSON_REPORT_LIST = 'FCL_EXPORT_DAILY_SALES_PERSON_REPORT_LIST';
export const FCL_EXPORT_TUES_REPORT_LIST = 'FCL_EXPORT_TUES_REPORT_LIST';
export const FCL_EXPORT_ONBOARD_REPORT = 'FCL_EXPORT_ONBOARD_REPORT';
export const FCL_EXPORT_ACTIVA_REPORT = 'FCL_EXPORT_ACTIVA_REPORT';
export const FCL_EXPORT_DAILY_REPORT = 'FCL_EXPORT_DAILY_REPORT'
export const FCL_EXPORT_PROFIT_AND_LOSS_REPORT = 'FCL_EXPORT_PROFIT_AND_LOSS_REPORT'
export const FCL_EXPORT_ITALY_VESSEL_REPORT = 'FCL_EXPORT_ITALY_VESSEL_REPORT'
export const FCL_EXPORT_CUSTOMER_LOSS_REPORT_LIST = 'FCL_EXPORT_CUSTOMER_LOSS_REPORT_LIST'

